import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";

import { setSection } from "../../../assignmentSlice";

import { useTTS } from "../../../../../hooks/useTTS";

import CorrectOverlay from "../../widgets/CorrectOverlay";

const VocaTestPage = ({
  currentPage,
  section,
  pageList,
  setPageList,
  currentIndex,
  setCurrentIndex,
  isReview = false,
}) => {
  const dispatch = useDispatch();
  const { speak, stopSpeaking, waitForCurrentSpeech } = useTTS();

  const [overlayVisible, setOverlayVisible] = useState(false);

  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  useEffect(() => {
    stopSpeaking();
    speak({ text: currentPage.data.text });
  }, [currentIndex]);

  const selectOption = async ({ option }) => {
    const newPageList = pageList.map((page, index) => {
      if (index === currentIndex) {
        return {
          ...page,
          data: {
            ...page.data,
            input: [...page.data.input, option],
          },
          isSubmitted: true,
        };
      }
      return page;
    });
    setPageList(newPageList);
    dispatch(setSection({ ...section, answer: newPageList }));

    setOverlayVisible(true);
    await delay(600);
    setOverlayVisible(false);

    if (currentIndex + 1 < pageList.length) {
      await waitForCurrentSpeech();
      setCurrentIndex(currentIndex + 1);
    }
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "20px",
        // 화살표 사이에 낀 본문이라 폭을 스스로 가져야 한다. 없으면 flex 줄에서
        // 내용물 최소폭(break-word 라 글자 1개)까지 쪼그라들어 카드가 세로
        // 슬리버로 부서졌다 (2026-08-27, 빌드마다 CSS 순서 따라 됐다 안 됐다 함).
        flex: 1,
        minWidth: 0,
      }}
    >
      <div
        style={{
          fontSize: "24px",
        }}
      >
        주어진 단어의 올바른 뜻을 선택하세요.
      </div>
      <div
        style={{
          fontSize: "32px",
          marginBottom: "40px",
        }}
      >
        {currentPage.data.text}
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "10px",
        }}
      >
        {currentPage.data.options.map((option) => {
          return (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "80vw",
                height: "10vh",
                border: "1px solid #EBEBEB",
                borderRadius: "5px",
                boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.25)",
                cursor:
                  !currentPage.data.input.includes(currentPage.data.answer) &&
                  "pointer",
                backgroundColor:
                  currentPage.data.input.includes(currentPage.data.answer) &&
                  currentPage.data.answer === option
                    ? "rgba(45, 240, 52, 0.5)"
                    : currentPage.data.input.includes(option) &&
                      "rgba(240, 52, 52, 0.5)",
                fontSize: "20px",
              }}
              onClick={() => {
                if (currentPage.data.input.includes(currentPage.data.answer))
                  return;
                selectOption({ option });
              }}
            >
              {option}
            </div>
          );
        })}
      </div>
      <div
        style={{
          opacity: overlayVisible ? 1 : 0, // Fade-in/out
          visibility: overlayVisible ? "visible" : "hidden", // DOM에서 숨김
          transition: "opacity 200ms ease-out, visibility 200ms",
        }}
      >
        <CorrectOverlay
          bool={currentPage.data.input.includes(currentPage.data.answer)}
        />
      </div>
    </div>
  );
};

export default VocaTestPage;
